import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Content from './Content';

const useStyles = makeStyles((theme) => ({
  
}));

function CustomIdentifiers(props) {
  const classes = useStyles();
  
  return (
    <Content>
      <h1>CustomIdentifiers</h1>
    </Content>
  );
}

export default CustomIdentifiers;
